import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SearchChipProps {
  query: string;
  onClear: () => void;
}

export function SearchChip({ query, onClear }: SearchChipProps) {
  const trimmed = query?.trim() ?? "";
  if (!trimmed) return null;

  const display = trimmed.length > 24 ? `${trimmed.slice(0, 24)}…` : trimmed;

  return (
    <div className="flex items-center">
      <Button
        variant="outline"
        type="button"
        title={`Search: "${trimmed}"`}
        className="gap-1.5 h-9 text-sm border-primary bg-primary/10 text-primary dark:text-[hsl(var(--aurora-tx-link))] hover:bg-primary/15 hover:text-primary dark:hover:text-[hsl(var(--aurora-tx-link))] cursor-default"
        onClick={(e) => e.preventDefault()}
      >
        <span className="flex items-center text-current">
          <Search className="h-3.5 w-3.5" />
        </span>
        <span className="max-w-[200px] truncate">&ldquo;{display}&rdquo;</span>
        <span
          role="button"
          tabIndex={0}
          aria-label="Clear search"
          className="ml-0.5 rounded-full p-0.5 hover:bg-primary/20 transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.stopPropagation();
              onClear();
            }
          }}
        >
          <X className="h-3 w-3" />
        </span>
      </Button>
    </div>
  );
}